@if (categoryData) {
  <div class="category-sidebar">
    <div class="section-heading">
      <span class="item-title">{{ categoryData.title }}</span>
    </div>
    @for (section of categoryData.children; track section) {
      <div class="category-container">
        <div class="category" [ngClass]="{ selected: isSelected(section) }" (click)="onSelectCategory(section, $event)">
          <span class="title" [ngClass]="{ active: isSelected(section) }" [innerHTML]="section.title"></span>
          @if (section.path && isToggled) {
          <div class="category-link">
            @if (section.icon) {
            <lucide-icon [name]="section.icon" class="lucide-icon"></lucide-icon>
            }
            <span class="category-link-title" [innerHTML]="section.title"></span>
          </div>
          }
        </div>
        @if (section.children) {
        <ul class="section-items parent-category">
          <ng-container *ngTemplateOutlet="renderItems; context: { items: section.children }"></ng-container>
        </ul>
        }
        <hr />
      </div>
    }
    <ng-template #renderItems let-items="items">
      @for (item of items; track item) {
        <li class="product-list-item">
          <div
            class="item-row"
            [ngClass]="{
              expandable: item.children,
              active: isSelected(item),
              clickable: !item.children || item.children.length === 0
            }"
            (click)="item.children ? toggle(item, $event) : onSelectCategory(item, $event)">
            <div class="item-content">
              <lucide-icon *ngIf="item.icon" [name]="item.icon" class="lucide-icon"></lucide-icon>
              <span
                class="item-title-value"
                [ngClass]="{
                  selected: isSelected(item),
                  'has-children': item.children,
                  expanded: item.expanded
                }" [innerHTML]="item.title">
              </span>
            </div>

            <button-icon
              class="category-icon"
              *ngIf="item.children"
              iconattributes="-xsm"
              [icon]="item.expanded ? 'dropdown' : 'singlearrow-right'"
              (click)="toggle(item, $event)">
            </button-icon>
          </div>
          @if (item.children) {
            <button-icon
              class="category-icon"
              iconattributes="-xsm"
              [icon]="item.expanded ? 'chevron-down' : 'arrow-right'"
              (click)="toggle(item, $event)">
            </button-icon>
          }
          @if (item.expanded && item.children) {
            <ul class="child-items">
              <ng-container *ngTemplateOutlet="renderItems; context: { items: item.children }"></ng-container>
            </ul>
          }
        </li>
      }
    </ng-template>
  </div>
}
